import {
  Menu as ChakraMenu,
  MenuButton as ChakraMenuButton,
  MenuButtonProps,
  MenuItem as ChakraMenuItem,
  MenuItemProps,
  MenuList as ChakraMenuList,
  MenuListProps,
  MenuProps,
} from '@chakra-ui/react';

export const Menu = ChakraMenu;
export const MenuButton = ChakraMenuButton;
export const MenuList = ChakraMenuList;
export const MenuItem = ChakraMenuItem;

export type { MenuProps, MenuButtonProps, MenuListProps, MenuItemProps };
